import styled from '@emotion/styled';
import { device } from '@landsbankinn/ui';
import React from 'react';

const Host = styled.div`
  margin: 0 -20px;

  @media ${device.tablet} {
    margin: 0;
  }
`;

const VideoEl = styled.video`
  width: 100%;
`;

interface IPorps {
  src: string;
  muted?: boolean;
  poster?: string;
  loop?: boolean;
  width?: number;
  autoPlay?: boolean;
}

export const Video = ({
  src,
  muted,
  poster,
  loop,
  width,
  autoPlay,
}: IPorps) => {
  return (
    <Host>
      <VideoEl
        width={width}
        loop={loop}
        poster={poster}
        muted={muted}
        playsInline
        autoPlay={autoPlay}
      >
        <source src={src} type="video/mp4"></source>
      </VideoEl>
    </Host>
  );
};
